<div *ngIf="coupons && coupons.length > 0" class="form-group m-form__group row">
  <label  class="col-lg-4 col-form-label">
    {{couponSelectLabel}}:
  </label>
  <div class="col-lg-4">
    <select #couponSelect class="form-control m-input" id="couponSelect" name="coupons" [(ngModel)]="selectedCouponId">
      <option selected value="0">-- No Coupon --</option>
      <option
        style="color:black;"
        *ngFor="let coupon of (coupons | orderBy: 'description')"
        [selected]="coupon.id == selectedCouponId"
        [ngValue]="coupon.id">
        {{ coupon.couponTitle }}
      </option>
    </select>
  </div>
</div>